/**
 * ClickAir form toast — shows brand notification from URL flags after form posts.
 * Liquid cannot reliably read request.params; success is detected client-side.
 */
(function () {
  var MESSAGES = {
    contact_posted: {
      type: 'success',
      title: 'Message sent',
      body: 'Thanks for reaching out — we will get back to you soon.'
    },
    customer_posted: {
      type: 'success',
      title: 'You are subscribed',
      body: 'Welcome to ClickAir — fresh updates, no spam.'
    },
    form_error_contact: {
      type: 'error',
      title: 'Message not sent',
      body: 'Please check your details and try again.'
    },
    form_error_subscribe: {
      type: 'error',
      title: 'Subscription failed',
      body: 'Please enter a valid email and try again.'
    }
  };

  function pickMessage(params) {
    if (params.get('contact_posted') === 'true') return MESSAGES.contact_posted;
    if (params.get('customer_posted') === 'true') return MESSAGES.customer_posted;
    if (params.get('form_error') === 'contact') return MESSAGES.form_error_contact;
    if (params.get('form_error') === 'subscribe') return MESSAGES.form_error_subscribe;
    return null;
  }

  function iconSvg(type) {
    if (type === 'success') {
      return '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="11" fill="currentColor"/><path d="M6.5 11.2L9.6 14.2L15.5 7.8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    return '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="11" fill="currentColor"/><path d="M11 6.5V12M11 15.5H11.01" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('form_error');
      url.hash = '';
      window.history.replaceState({}, '', url.pathname + url.search);
    } catch (e) {}
  }

  function showToast(msg) {
    if (document.querySelector('[data-ca-toast]')) return;

    var root = document.createElement('div');
    root.className = 'ca-toast ca-toast--' + msg.type;
    root.setAttribute('role', msg.type === 'error' ? 'alert' : 'status');
    root.setAttribute('aria-live', msg.type === 'error' ? 'assertive' : 'polite');
    root.setAttribute('data-ca-toast', '');
    root.style.cssText =
      'position:fixed;left:50%;bottom:28px;z-index:9999;width:min(420px,calc(100vw - 32px));';

    root.innerHTML =
      '<div class="ca-toast__inner">' +
      '<div class="ca-toast__icon">' +
      iconSvg(msg.type) +
      '</div>' +
      '<div class="ca-toast__copy">' +
      '<p class="ca-toast__title"></p>' +
      '<p class="ca-toast__body"></p>' +
      '</div>' +
      '<button type="button" class="ca-toast__close" aria-label="Dismiss" data-ca-toast-close>' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>';

    root.querySelector('.ca-toast__title').textContent = msg.title;
    root.querySelector('.ca-toast__body').textContent = msg.body;
    document.body.appendChild(root);

    requestAnimationFrame(function () {
      root.classList.add('is-visible');
    });

    function dismiss() {
      root.classList.remove('is-visible');
      setTimeout(function () {
        root.remove();
        cleanUrl();
      }, 320);
    }

    var closeBtn = root.querySelector('[data-ca-toast-close]');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    setTimeout(dismiss, 6500);
  }

  function stripLegacyHash() {
    if (!window.location.hash) return;
    if (
      window.location.hash.indexOf('ca-ccc') === -1 &&
      window.location.hash.indexOf('subscribe') === -1 &&
      window.location.hash.indexOf('ClickAir') === -1
    ) {
      return;
    }
    try {
      var url = new URL(window.location.href);
      url.hash = '';
      window.history.replaceState({}, '', url.pathname + url.search);
      window.scrollTo(
        0,
        Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight)
      );
    } catch (e) {}
  }

  function init() {
    stripLegacyHash();
    var params = new URLSearchParams(window.location.search);
    var msg = pickMessage(params);
    if (msg) showToast(msg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Allow sections to open a toast without a URL flag (e.g. form.posted_successfully?)
  window.ClickAirToast = {
    show: showToast,
    success: function (title, body) {
      showToast({ type: 'success', title: title, body: body });
    },
    error: function (title, body) {
      showToast({ type: 'error', title: title, body: body });
    }
  };
})();
